module.exports = __webpack_public_path__ + "static/media/2.70df1f1f.jpg";